// @ts-nocheck
/**
 * YMQ Custom — Modal UI
 *
 * Gộp 3 module nhỏ liên quan tới Modal UI:
 *  - MODULE 1: buildCustomModal()    → dựng custom modal + sync ATC + di chuyển addon/quote-price
 *  - MODULE 2: watchEstimateBlock()  → inject estimate metafield block vào modal
 *  - MODULE 3: syncYmqModal()        → đồng bộ trạng thái scroll với YMQ built-in modal
 *
 * Phụ thuộc:
 *  - 1-ymq-namespace.js phải được load trước.
 *
 * Public API (gắn vào window.YMQCustom):
 *  - YMQCustom.buildCustomModal({ ymqBox, realAtcBtn, quantityWrapper, wishlistWrapper })
 *  - YMQCustom.watchEstimateBlock(modalBox)
 *  - YMQCustom.syncYmqModal(openPopup)
 */

(function () {
  const YMQCustom = window.YMQCustom;
  if (!YMQCustom) {
    console.error(
      "[YMQCustom] Namespace chưa được khởi tạo. Hãy load 1-ymq-namespace.js trước.",
    );
    return;
  }

  /** @returns {string} */
  function getAddToCartLabel() {
    if (YMQCustom.isQuoteProduct) {
      return YMQCustom.config?.quoteSubmitLabel || "見積もりを依頼する";
    }
    return YMQCustom.config?.addToCartLabel || "カートに追加する";
  }

  function parsePriceNumber(value) {
    if (value === undefined || value === null || value === "") return null;
    const numeric = Number(String(value).replace(/[^\d.-]/g, ""));
    return Number.isNaN(numeric) ? null : numeric;
  }

  function isZeroYenProduct() {
    if (document.documentElement.getAttribute("data-zero-price") === "true") {
      return true;
    }

    const fromConfig = parsePriceNumber(YMQCustom.config?.productPrice);
    if (fromConfig !== null) return fromConfig === 0;

    const root = document.querySelector("[data-product-price]");
    if (root) {
      const amount = parsePriceNumber(root.getAttribute("data-product-price"));
      if (amount !== null) return amount === 0;
    }

    const priceRoot = document.querySelector(
      '[ref="priceContainer"].product-price-breakdown',
    );
    if (!priceRoot) return false;
    const nums = [...(priceRoot.textContent || "").matchAll(/¥\s*([\d,]+)/g)].map(
      (match) => Number(String(match[1]).replace(/,/g, "")),
    );
    return nums.length > 0 && nums.every((n) => n === 0);
  }

  function applyQuoteProductState() {
    const isQuote =
      isZeroYenProduct() && !!document.querySelector(".ymq-fake-open-btn");
    YMQCustom.isQuoteProduct = isQuote;
    document.documentElement.classList.toggle("ymq-quote-product", isQuote);
    if (isQuote) {
      document.documentElement.setAttribute("data-ymq-quote-product", "true");
    } else {
      document.documentElement.removeAttribute("data-ymq-quote-product");
    }

    const atcBtn =
      YMQCustom._modalAtcBtn ||
      document.querySelector(
        ".ymq-custom-modal-wrapper button[name='add'].add-to-cart-button",
      );
    if (atcBtn) setModalAtcLabel(atcBtn, getAddToCartLabel());
    return isQuote;
  }

  /**
   * Trong YMQ modal luôn hiển thị label add-to-cart (không hiện 売り切れ).
   * @param {HTMLElement} atcButton
   * @param {string} label
   */
  function setModalAtcLabel(atcButton, label) {
    if (!atcButton || !label) return;
    const content = atcButton.querySelector(".add-to-cart-text__content");
    if (content) {
      const spans = content.querySelectorAll("span");
      const target = spans.length ? spans[spans.length - 1] : content;
      if ((target.textContent || "").trim() !== label) {
        target.textContent = label;
      }
      return;
    }

    const textWrap = atcButton.querySelector(".add-to-cart-text");
    if (!textWrap) {
      if ((atcButton.textContent || "").trim() !== label) {
        atcButton.textContent = label;
      }
      return;
    }

    if (
      textWrap.childNodes.length === 1 &&
      textWrap.firstChild?.nodeType === Node.TEXT_NODE
    ) {
      textWrap.textContent = label;
      return;
    }

    const icon = textWrap.querySelector(".add-to-cart-icon");
    const textSpan = document.createElement("span");
    textSpan.className = "add-to-cart-text__content";
    textSpan.innerHTML = `<span><span>${label}</span></span>`;
    textWrap.replaceChildren(...(icon ? [icon] : []), textSpan);
  }

  /**
   * Giữ label add-to-cart khi variant morph / YMQ cập nhật DOM.
   * @param {HTMLButtonElement} atcButton
   * @param {HTMLElement} modalWrapper
   */
  function watchModalAtcLabel(atcButton, modalWrapper) {
    YMQCustom._modalAtcBtn = atcButton;
    const apply = () => {
      if (!modalWrapper.contains(atcButton)) return;
      setModalAtcLabel(atcButton, getAddToCartLabel());
    };

    apply();
    new MutationObserver(apply).observe(atcButton, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  // ============================================================
  // MODULE 1 — BUILD CUSTOM MODAL
  // ============================================================
  function buildCustomModal({
    ymqBox,
    realAtcBtn,
    quantityWrapper,
    wishlistWrapper,
    changeStateWrapper,
    selectAddressFrom,
  }) {
    const btnRow = document.createElement("div");
    btnRow.className = "ymq-btn-row";

    const openBtn = document.createElement("button");
    openBtn.type = "button";
    openBtn.className = "ymq-fake-open-btn";
    openBtn.innerText = "見積もりフォーム";
    btnRow.appendChild(openBtn);
    btnRow.appendChild(wishlistWrapper);
    const buyNowBtn = document.querySelector(".buy-buttons-block");
    buyNowBtn?.parentNode?.insertBefore(btnRow, buyNowBtn);
    applyQuoteProductState();

    const modalWrapper = document.createElement("div");
    modalWrapper.className = "ymq-custom-modal-wrapper";

    const modalBox = document.createElement("div");
    modalBox.className = "ymq-custom-modal-box";
    modalBox.innerHTML = `
            <div class="ymq-modal-sticky-header">
                <div class="ymq-modal-close-btn">&times;</div>
                <h3 class="ymq-modal-title">オプションを選択</h3>
            </div>
        `;

    const modalBody = document.createElement("div");
    modalBody.className = "ymq-modal-body";
    modalBox.appendChild(modalBody);
    modalWrapper.appendChild(modalBox);
    btnRow.parentNode?.insertBefore(modalWrapper, btnRow.nextSibling);

    const grid = document.createElement("div");
    grid.className = "ymq-modal-grid";

    const leftCol = document.createElement("div");
    leftCol.className = "ymq-modal-col-left";

    const rightCol = document.createElement("div");
    rightCol.className = "ymq-modal-col-right";

    grid.appendChild(leftCol);
    grid.appendChild(rightCol);
    modalBody.appendChild(grid);

    leftCol.appendChild(ymqBox);

    // Slot cố định cho <form-check-address> — nằm NGOÀI ymq-option để YMQ
    // rebuild không xóa node. Visibility sync với address group (4-ymq-address-validator).
    const addressFormSlot = document.createElement("div");
    addressFormSlot.className = "ymq-address-form-slot hidden";
    addressFormSlot.setAttribute("data-ymq-address-form-slot", "");
    leftCol.appendChild(addressFormSlot);
    YMQCustom.addressFormSlot = addressFormSlot;

    const footer = document.createElement("div");
    footer.className = "ymq-modal-footer-flex";
    if (quantityWrapper) footer.appendChild(quantityWrapper);
    footer.appendChild(realAtcBtn);
    watchModalAtcLabel(realAtcBtn, modalWrapper);
    if (changeStateWrapper) {
      footer.appendChild(changeStateWrapper);
      // Wrapper được set sẵn class `hidden` trong Liquid để tránh "nhấp nháy"
      // (FOUC) lúc page load trước khi JS chạy. Sau khi đã move vào vị trí
      // chính xác trong footer → remove `hidden` để hiện ra.
      changeStateWrapper.classList.remove("hidden");
    }
    rightCol.appendChild(footer);

    // ── Move .button-quote-price into footer, below ATC ──
    function moveQuotePrice() {
      const quoteBtn =
        ymqBox.querySelector(".button-quote-price") ||
        document.querySelector(
          ".ymq-custom-modal-wrapper .button-quote-price, ymq-option .button-quote-price",
        );
      if (!quoteBtn) return;

      const existing = rightCol.querySelector(".button-quote-price");
      if (existing && existing !== quoteBtn) existing.remove();
      if (quoteBtn.parentElement !== footer) footer.appendChild(quoteBtn);
    }
    moveQuotePrice();
    YMQCustom.observeIdle(
      ymqBox,
      { childList: true, subtree: true },
      moveQuotePrice,
      "move-quote-price",
    );

    // (Bỏ syncAtcState cũ — quyền control `realAtcBtn.disabled` giờ thuộc
    // hoàn toàn về module `4-ymq-address-validator.js`, dựa trên:
    //  - các field [ymq-option-validate="required"] đã fill
    //  - .shipping_fee_auto_select đã chọn
    // Có syncAtcState cũ ở đây sẽ đè validator → ATC luôn enable.)

    // ── Move .ymq-option-addon into right col, above footer ──
    function moveAddon() {
      const addon = ymqBox.querySelector(".ymq-option-addon");
      if (!addon) return;

      const existing = rightCol.querySelector(".ymq-option-addon");
      // Addon mới đã chính là addon đang hiển thị → không làm gì (tránh churn/loop).
      if (existing === addon) return;
      // Có addon cũ (stale, YMQ không còn update) → bỏ đi trước khi gắn cái mới.
      if (existing) existing.remove();

      rightCol.insertBefore(addon, footer);
    }
    moveAddon();
    YMQCustom.observeIdle(
      ymqBox,
      { childList: true, subtree: true },
      moveAddon,
      "move-addon",
    );

    function isCustomerLoggedIn() {
      return (
        window.Theme?.customer?.loggedIn === true ||
        document.body?.dataset?.customerLoggedIn === "true"
      );
    }

    function showGuestQuoteNotice() {
      let dialog = document.getElementById("ymq-login-required-dialog");
      if (!dialog) {
        dialog = document.createElement("dialog");
        dialog.id = "ymq-login-required-dialog";
        dialog.className = "ymq-login-required-dialog";
        dialog.innerHTML = `
          <p class="ymq-login-required-dialog__text">見積もりを続けるには、<br><a href="/pages/register">会員登録</a>または<a data-ymq-login href="#">ログイン</a>してください。</p>
          <form method="dialog">
            <button type="submit" class="ymq-login-required-dialog__close">閉じる</button>
          </form>
        `;
        dialog.addEventListener("click", (event) => {
          if (event.target === dialog) dialog.close();
        });
        document.body.appendChild(dialog);
      }
      const loginLink = dialog.querySelector("[data-ymq-login]");
      if (loginLink) {
        const returnTo = `${window.location.pathname}${window.location.search}`;
        loginLink.href = `/customer_authentication/login?return_to=${encodeURIComponent(returnTo)}`;
      }
      if (!dialog.open) dialog.showModal();
    }

    function openPopup() {
      const ymqModal = document.getElementById("ymqmodal-option-list");
      if (ymqModal?.classList.contains("ymq-modal-open")) {
        ymqModal.querySelector("[data-ymqmodal-close]")?.click();
      }
      modalWrapper.classList.add("active");
      document.body.classList.add("ymq-no-scroll");
      document.documentElement.classList.add("ymq-no-scroll");
      document
        .querySelector(".header-section")
        ?.classList.add("ymq-modal-open");
      YMQCustom.initInitialGroup();
    }

    function closePopup() {
      modalWrapper.classList.remove("active");
      document.body.classList.remove("ymq-no-scroll");
      document.documentElement.classList.remove("ymq-no-scroll");
      document
        .querySelector(".header-section")
        ?.classList.remove("ymq-modal-open");
    }

    openBtn.addEventListener("click", (e) => {
      e.preventDefault();
      if (!isCustomerLoggedIn()) {
        showGuestQuoteNotice();
        return;
      }
      openPopup();
    });
    modalBox
      ?.querySelector(".ymq-modal-close-btn")
      ?.addEventListener("click", closePopup);
    modalWrapper.addEventListener("click", (e) => {
      if (e.target === modalWrapper) closePopup();
    });
    realAtcBtn.style.removeProperty("pointer-events");
    realAtcBtn.addEventListener("click", () => {
      if (YMQCustom.isQuoteProduct) return;
      setTimeout(closePopup, 150);
    });
    // Quote submit: bindProductQuoteSubmitOnce (document capture).

    YMQCustom.closePopup = closePopup;

    return { modalWrapper, modalBox, openPopup, closePopup, addressFormSlot };
  }

  const GLOBO_KIGAE_QUOTE_FORM_ID = "148984";
  const GLOBO_PRODUCT_QUOTE_FORM_ID = "165388";

  function getProductQuoteFormId() {
    return (
      YMQCustom.config?.productQuoteFormId || GLOBO_PRODUCT_QUOTE_FORM_ID
    );
  }

  function isQuoteSubmitButton(el) {
    if (!(el instanceof Element)) return false;
    const btn = el.closest(
      ".ymq-custom-modal-wrapper button[name='add'].add-to-cart-button, #ymqmodal-option-list .ymq-option-list-add-cart",
    );
    if (!btn) return false;
    if (YMQCustom.isQuoteProduct) return btn;
    const text = (btn.textContent || "").replace(/\s+/g, "");
    if (text.includes("見積もりを依頼する")) return btn;
    return null;
  }

  function bindProductQuoteSubmitOnce() {
    if (YMQCustom._productQuoteSubmitBound) return;
    YMQCustom._productQuoteSubmitBound = true;

    window.addEventListener(
      "click",
      (e) => {
        const btn = isQuoteSubmitButton(e.target);
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        submitProductQuoteForm(btn);
      },
      true,
    );

    document.addEventListener(
      "submit",
      (e) => {
        if (!YMQCustom.isQuoteProduct) return;
        const form = e.target;
        if (!(form instanceof HTMLFormElement)) return;

        // Không chặn form check địa chỉ / form Globo / form khác trong modal
        if (
          form.closest("form-check-address") ||
          form.hasAttribute("data-main-form") ||
          form.closest(".globo-form-app") ||
          form.closest("#globo-formbuilder-165388")
        ) {
          return;
        }

        // Chỉ chặn submit form sản phẩm (add-to-cart)
        const atc = form.querySelector(
          'button[name="add"].add-to-cart-button',
        );
        if (!atc) return;
        if (!form.contains(atc)) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      },
      true,
    );
  }

  bindProductQuoteSubmitOnce();

  function readCustomerContact() {
    try {
      const el = document.getElementById("CustomerContact");
      if (!el?.textContent) return null;
      return JSON.parse(el.textContent);
    } catch (_) {
      return null;
    }
  }

  function readEnteredFullAddress() {
    const slot =
      YMQCustom.addressFormSlot ||
      document.querySelector("[data-ymq-address-form-slot]");
    const input =
      slot?.querySelector('input[name="full_address"]') ||
      document.getElementById("osm-search-input");
    return String(input?.value || "").trim();
  }

  function getOptionBoxLabel(box) {
    const label =
      box.querySelector(".ymq_lable") ||
      box.querySelector(".ymq-option-title") ||
      box.querySelector("[ymq-option-label]");
    const raw =
      label?.getAttribute?.("ymq-option-label") ||
      (label?.textContent || "").replace(/\*/g, "").trim();
    return (raw || "").replace(/\s+/g, " ").trim();
  }

  function getOptionBoxValue(box) {
    if (box.querySelector(".ymq-app-select-placeholder")) return "";

    const select = box.querySelector("select");
    if (select) {
      const selected = select.options[select.selectedIndex];
      if (
        !selected ||
        selected.dataset.placeholder ||
        !(select.value || "").trim()
      ) {
        return "";
      }
      return (selected.textContent || select.value || "").trim();
    }

    const single = box.querySelector(".ymq-app-select-single");
    if (single) return (single.textContent || "").trim();

    const optionValue = box.querySelector(
      ".ymq-app-select-values .ymq-option-value",
    );
    if (optionValue) return (optionValue.textContent || "").trim();

    const text = box.querySelector(
      "input.ymq-option-text, input[type='text'], input[type='number'], textarea",
    );
    if (text) return (text.value || "").trim();

    const checks = [
      ...box.querySelectorAll(
        "input[type='checkbox']:checked, input[type='radio']:checked",
      ),
    ];
    if (checks.length) {
      return checks
        .map((el) => {
          const lab =
            el.closest("label") ||
            box.querySelector(`label[for="${el.id}"]`) ||
            el.parentElement;
          return (lab?.textContent || el.value || "").trim();
        })
        .filter(Boolean)
        .join(", ");
    }

    const selectedName = box.querySelector(".ymq-option-title-right-name");
    if (selectedName) return (selectedName.textContent || "").trim();

    return "";
  }

  function extractAddonPrice(text) {
    const source = String(text || "").replace(/\s+/g, "");
    const match = source.match(/[(（]\+[¥￥][\d,]+(?:\.\d+)?[)）]/);
    if (!match) return "";
    const amount = Number(match[0].replace(/[^\d.]/g, ""));
    if (!Number.isFinite(amount) || amount === 0) return "";
    return `(+¥${amount.toLocaleString("ja-JP")})`;
  }

  function getOptionAddonPrice(box, value) {
    if (extractAddonPrice(value)) return "";

    const select = box.querySelector("select");
    const selected = select?.options?.[select.selectedIndex];
    const fromOption =
      extractAddonPrice(selected?.textContent) ||
      extractAddonPrice(selected?.getAttribute?.("data-ymq-money")) ||
      extractAddonPrice(selected?.getAttribute?.("data-price"));
    if (fromOption) return fromOption;

    const selectedMoney = Number(
      String(
        selected?.getAttribute?.("data-ymq-money") ||
          selected?.getAttribute?.("data-price") ||
          "",
      ).replace(/[^\d.-]/g, ""),
    );
    if (Number.isFinite(selectedMoney) && selectedMoney !== 0) {
      const sign = selectedMoney > 0 ? "+" : "-";
      return `(${sign}¥${Math.abs(selectedMoney).toLocaleString("ja-JP")})`;
    }

    const title = box.querySelector(".ymq-option-title");
    const fromTitle = extractAddonPrice(title?.textContent);
    if (fromTitle) return fromTitle;

    const visible = box.querySelector(
      ".ymq-app-select-single, .ymq-option-title-right-name",
    );
    return extractAddonPrice(visible?.textContent);
  }

  function collectYmqQuoteLines() {
    const lines = [];
    const boxes = document.querySelectorAll(
      "ymq-option .ymq-options-box, .ymq-custom-modal-wrapper .ymq-options-box",
    );
    boxes.forEach((box) => {
      if (!(box instanceof HTMLElement)) return;
      if (box.classList.contains("ymq-option-condition-hide")) return;
      if (box.classList.contains("button-quote-price")) return;
      if (box.classList.contains("estimate_explanation")) return;
      if (box.classList.contains("ymq-shipping-address")) return;

      const type = box.getAttribute("ymq-option-type");
      if (type === "11" || type === "15" || type === "26" || type === "23") {
        return;
      }

      const key = getOptionBoxLabel(box);
      const value = getOptionBoxValue(box);
      if (!key || !value) return;
      if (/選択してください/.test(value) || /^--.*--$/.test(value)) return;
      if (value.includes("上のオプションを先に")) return;

      const addonPrice = getOptionAddonPrice(box, value);
      lines.push(addonPrice ? `${key}: ${value} ${addonPrice}` : `${key}: ${value}`);
    });
    return lines;
  }

  function getYmqAddonPriceLine() {
    const span = document.querySelector(
      ".ymq-custom-modal-wrapper .ymq-modal-col-right .ymq-option-addon .ymq-option-addon-price .ymq-price-span",
    );
    if (!span) return "";
    const money = (span.getAttribute("data-ymq-money") || "").replace(
      /[^\d.-]/g,
      "",
    );
    const amount = Number(money);
    if (money !== "" && Number.isFinite(amount)) {
      return `合計追加価格: ¥${amount.toLocaleString("ja-JP")}`;
    }
    const text = (span.textContent || "").replace(/\s+/g, "").trim();
    if (!text) return "";
    const price = /^[¥￥]/.test(text) ? text : `¥${text}`;
    return `合計追加価格: ${price}`;
  }

  function collectFromConfirmTable() {
    const lines = [];
    const rows = document.querySelectorAll(
      "#ymqmodal-option-list .ymq-option-list-table tr",
    );
    rows.forEach((row) => {
      const cells = row.querySelectorAll("td, th");
      if (cells.length < 2) return;
      const key = (cells[0].textContent || "").replace(/\s+/g, " ").trim();
      const value = (cells[1].textContent || "").replace(/\s+/g, " ").trim();
      if (!key || !value) return;
      if (/オプション名|オプション価値|価格/.test(key)) return;
      lines.push(`${key}: ${value}`);
    });
    return lines;
  }

  function buildQuoteContent() {
    let lines = collectYmqQuoteLines();
    if (!lines.length) lines = collectFromConfirmTable();
    const priceLine = getYmqAddonPriceLine();
    if (priceLine) lines.push(priceLine);
    return lines.join("\n");
  }

  function getQuoteSubmitLabel() {
    return YMQCustom.config?.quoteSubmitLabel || "見積もりを依頼する";
  }

  function syncQuoteConfirmButton() {
    if (!YMQCustom.isQuoteProduct) return;
    const ymqModal = document.getElementById("ymqmodal-option-list");
    if (!ymqModal) return;

    const addBtn = ymqModal.querySelector(".ymq-option-list-add-cart");
    if (!addBtn) return;

    const label = getQuoteSubmitLabel();
    addBtn.classList.add("ymq-quote-confirm-btn");
    addBtn.setAttribute("aria-label", label);

    // Ẩn icon giỏ hàng nếu có
    addBtn
      .querySelectorAll("svg, img, .svg-wrapper, .add-to-cart-icon, i")
      .forEach((el) => {
        el.style.display = "none";
      });

    // Đổi text nút (giữ cấu trúc DOM của YMQ)
    const textNodes = [...addBtn.childNodes].filter(
      (n) => n.nodeType === Node.TEXT_NODE && (n.textContent || "").trim(),
    );
    if (textNodes.length) {
      textNodes[0].textContent = label;
      return;
    }

    let textEl =
      addBtn.querySelector(".ymq-option-list-add-cart-text") ||
      addBtn.querySelector("span:not(.svg-wrapper)");
    if (textEl) {
      textEl.textContent = label;
      return;
    }

    if ((addBtn.textContent || "").trim() !== label) {
      addBtn.textContent = label;
    }
  }

  function scheduleQuoteConfirmButtonSync() {
    syncQuoteConfirmButton();
    clearTimeout(scheduleQuoteConfirmButtonSync._t1);
    clearTimeout(scheduleQuoteConfirmButtonSync._t2);
    scheduleQuoteConfirmButtonSync._t1 = setTimeout(syncQuoteConfirmButton, 50);
    scheduleQuoteConfirmButtonSync._t2 = setTimeout(syncQuoteConfirmButton, 250);
  }

  function closeYmqConfirmModal() {
    const ymqModal = document.getElementById("ymqmodal-option-list");
    if (!ymqModal) return;
    // Không click data-ymqmodal-close — handler đó sẽ mở lại custom modal.
    ymqModal.classList.remove("ymq-modal-open");
  }

  function forceCloseAllYmqModals() {
    closeYmqConfirmModal();
    closeYmqModal();
    document
      .querySelectorAll(".ymq-custom-modal-wrapper")
      .forEach((el) => el.classList.remove("active"));
    document.body.classList.remove("ymq-no-scroll");
    document.documentElement.classList.remove("ymq-no-scroll");
    document
      .querySelector(".header-section")
      ?.classList.remove("ymq-modal-open");
  }

  function bindQuoteConfirmSubmitOnce() {
    if (YMQCustom._quoteConfirmSubmitBound) return;
    YMQCustom._quoteConfirmSubmitBound = true;

    window.addEventListener(
      "click",
      (e) => {
        if (!YMQCustom.isQuoteProduct) return;
        const btn = e.target instanceof Element
          ? e.target.closest(
              "#ymqmodal-option-list .ymq-option-list-add-cart, #ymqmodal-option-list .ymq-quote-confirm-btn",
            )
          : null;
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        submitProductQuoteForm(btn);
      },
      true,
    );

    const attachModalObserver = (ymqModal) => {
      if (!ymqModal || ymqModal.dataset.ymqQuoteObs === "1") return;
      ymqModal.dataset.ymqQuoteObs = "1";
      new MutationObserver(() => {
        if (!ymqModal.classList.contains("ymq-modal-open")) return;
        if (!YMQCustom.isQuoteProduct) return;
        scheduleQuoteConfirmButtonSync();
      }).observe(ymqModal, {
        attributes: true,
        attributeFilter: ["class"],
        childList: true,
        subtree: true,
      });
    };

    const existing = document.getElementById("ymqmodal-option-list");
    if (existing) {
      attachModalObserver(existing);
    } else {
      const boot = new MutationObserver(() => {
        const modal = document.getElementById("ymqmodal-option-list");
        if (!modal) return;
        boot.disconnect();
        attachModalObserver(modal);
      });
      boot.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  bindQuoteConfirmSubmitOnce();

  function findGloboControlInput(formRoot, labelMatchers) {
    const controls = formRoot.querySelectorAll(".globo-form-control");
    for (const control of controls) {
      const labelText = (
        control.querySelector("label, .globo-label")?.textContent || ""
      ).replace(/\s+/g, " ");
      const matched = labelMatchers.some((m) => labelText.includes(m));
      if (!matched) continue;
      const field = control.querySelector(
        "input:not([type='hidden']):not([type='submit']):not([type='button']), textarea, select",
      );
      if (field) return field;
    }
    return null;
  }

  function setFieldValue(field, value) {
    if (!field) return;
    const next = value == null ? "" : String(value);
    field.value = next;
    field.dispatchEvent(new Event("input", { bubbles: true }));
    field.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function getGloboQuoteFormRoot(formId) {
    return (
      document.querySelector(`#globo-formbuilder-${formId}`) ||
      document.querySelector(
        `.globo-formbuilder[data-id="${btoa(String(formId)).replace(/=+$/, "")}"]`,
      ) ||
      document.querySelector(`.globo-form-app[data-id="${formId}"]`)?.closest(
        ".globo-formbuilder, #globo-formbuilder-" + formId,
      ) ||
      document.querySelector(`.globo-form-app[data-id="${formId}"]`)
    );
  }

  function waitForGloboForm(formId, timeout = 8000) {
    const start = Date.now();
    return new Promise((resolve, reject) => {
      const tick = () => {
        const root = getGloboQuoteFormRoot(formId);
        const form =
          root?.querySelector?.("form") ||
          document.querySelector(
            `form[data-id="${formId}"], #globo-formbuilder-${formId} form`,
          );
        if (form) {
          resolve({ root, form });
          return;
        }
        if (Date.now() - start >= timeout) {
          reject(new Error("Globo form not ready"));
          return;
        }
        requestAnimationFrame(tick);
      };
      tick();
    });
  }

  async function ensureGloboFormReady(formId) {
    document.documentElement.classList.add("ymq-quote-submitting");

    const tryFind = () => {
      const root = getGloboQuoteFormRoot(formId);
      const form =
        root?.querySelector?.("form") ||
        document.querySelector(
          `form[data-id="${formId}"], #globo-formbuilder-${formId} form, .globo-form-app[data-id="${formId}"] form`,
        );
      return form ? { root, form } : null;
    };

    let found = tryFind();
    if (found) return found;

    const fb =
      document.querySelector(
        `#globo-formbuilder-${formId} .floating-button.circle`,
      ) ||
      document.querySelector(
        `.globo-formbuilder[data-id="${btoa(String(formId)).replace(/=+$/, "")}"] .floating-button.circle`,
      );

    if (fb && window.Globo?.FormBuilder?.showFloatingForm) {
      try {
        Globo.FormBuilder.showFloatingForm(fb);
      } catch (_) {
        fb.click();
      }
    } else if (fb) {
      fb.click();
    }

    found = await waitForGloboForm(formId, 10000);
    document
      .querySelectorAll(
        `#globo-formbuilder-${formId} .globo-form-app, .globo-form-app[data-id="${formId}"]`,
      )
      .forEach((app) => app.classList.remove("active"));
    return found;
  }

  async function submitProductQuoteForm(atcBtn) {
    if (YMQCustom._quoteSubmitting) return;
    YMQCustom._quoteSubmitting = true;

    const label = getQuoteSubmitLabel();
    const prevDisabled = atcBtn?.disabled;
    const prevHtml = atcBtn?.innerHTML;
    if (atcBtn) {
      atcBtn.disabled = true;
      atcBtn.setAttribute("aria-busy", "true");
      const content =
        atcBtn.querySelector(".add-to-cart-text__content span span") ||
        atcBtn.querySelector(".add-to-cart-text__content") ||
        atcBtn;
      if (content) content.textContent = "送信中...";
    }

    try {
      const formId = getProductQuoteFormId();
      const contact = readCustomerContact() || {};
      const quoteContent = buildQuoteContent();
      console.info("[YMQCustom] quote submit", {
        formId,
        hasContact: !!contact.email,
        lines: quoteContent.split("\n").length,
      });

      if (!quoteContent.trim()) {
        alert("見積もり内容が空です。オプションを選択してください。");
        return;
      }

      const { form } = await ensureGloboFormReady(formId);

      const emailField = findGloboControlInput(form, [
        "メールアドレス",
        "メール",
        "Email",
      ]);
      const nameField = findGloboControlInput(form, [
        "お名前",
        "氏名",
        "名前",
        "Name",
      ]);
      const phoneField = findGloboControlInput(form, [
        "電話",
        "ご連絡先",
        "Phone",
      ]);
      const addressField = findGloboControlInput(form, ["住所", "Address"]);
      const contentField = findGloboControlInput(form, [
        "見積もり内容",
        "見積内容",
        "内容",
      ]);

      if (!contentField) {
        throw new Error("Globo form fields not found (見積もり内容)");
      }

      setFieldValue(emailField, contact.email || "");
      setFieldValue(nameField, contact.name || "");
      setFieldValue(phoneField, contact.phone || "");
      setFieldValue(addressField, readEnteredFullAddress());
      setFieldValue(contentField, quoteContent);

      // Globo API CORS không cho phép fetch + credentials từ storefront.
      // Submit native qua iframe ẩn (không bị CORS).
      await submitGloboViaIframe(form);

      alert(
        "見積もり依頼を送信しました。\n担当者より折り返しご連絡いたします。",
      );
      forceCloseAllYmqModals();
    } catch (err) {
      console.error("[YMQCustom] product quote submit failed:", err);
      alert(
        "見積もり送信に失敗しました。しばらくしてから再度お試しください。\n" +
          (err?.message || ""),
      );
    } finally {
      document.documentElement.classList.remove("ymq-quote-submitting");
      document
        .querySelectorAll(
          `#globo-formbuilder-${getProductQuoteFormId()} .globo-form-app, .globo-form-app[data-id="${getProductQuoteFormId()}"]`,
        )
        .forEach((app) => app.classList.remove("active"));
      YMQCustom._quoteSubmitting = false;
      if (atcBtn) {
        atcBtn.disabled = prevDisabled;
        atcBtn.removeAttribute("aria-busy");
        if (prevHtml != null) {
          atcBtn.innerHTML = prevHtml;
        } else {
          setModalAtcLabel(atcBtn, label);
        }
      }
    }
  }

  function submitGloboViaIframe(form) {
    return new Promise((resolve, reject) => {
      if (!(form instanceof HTMLFormElement)) {
        reject(new Error("Invalid Globo form"));
        return;
      }

      const iframeName = "ymq-globo-silent-" + Date.now();
      const iframe = document.createElement("iframe");
      iframe.name = iframeName;
      iframe.setAttribute("aria-hidden", "true");
      iframe.style.cssText =
        "position:fixed;width:1px;height:1px;opacity:0;pointer-events:none;left:-9999px;top:0;border:0;";
      document.body.appendChild(iframe);

      const prevTarget = form.getAttribute("target");
      const prevAction = form.getAttribute("action");
      form.setAttribute("target", iframeName);

      let settled = false;
      const finish = (ok, err) => {
        if (settled) return;
        settled = true;
        if (prevTarget == null) form.removeAttribute("target");
        else form.setAttribute("target", prevTarget);
        if (prevAction != null) form.setAttribute("action", prevAction);
        setTimeout(() => iframe.remove(), 2000);
        if (ok) resolve();
        else reject(err || new Error("Globo iframe submit failed"));
      };

      iframe.addEventListener("load", () => finish(true));
      // Cross-origin load vẫn fire; timeout phòng trường hợp không load
      setTimeout(() => finish(true), 2500);

      try {
        // HTMLFormElement.submit() không fire event submit → tránh bị listener chặn
        HTMLFormElement.prototype.submit.call(form);
      } catch (err) {
        finish(false, err);
      }
    });
  }

  function isYmqQuoteRequestTarget(target) {
    const el = target instanceof Element ? target : target?.parentElement;
    if (!el) return false;
    if (el.closest("product-card")) return false;
    return !!(
      el.closest(".button-quote-price") ||
      el.closest('[ymq-option-label="見積もりはこちら"]')
    );
  }

  /**
   * Cùng logic nút 見積もり依頼をする trên /pages/kitchin-o-kigaeru.
   * Gắn trên window capture để chạy trước handler của YMQ.
   */
  function closeYmqModal() {
    if (typeof YMQCustom.closePopup === "function") {
      YMQCustom.closePopup();
      return;
    }
    document
      .querySelector(".ymq-custom-modal-wrapper")
      ?.classList.remove("active");
    document.body.classList.remove("ymq-no-scroll");
    document.documentElement.classList.remove("ymq-no-scroll");
    document
      .querySelector(".header-section")
      ?.classList.remove("ymq-modal-open");
  }

  function openKigaeruGloboForm(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    var fb = document.querySelector(
      "#globo-formbuilder-" + GLOBO_KIGAE_QUOTE_FORM_ID + " .floating-button.circle",
    );
    closeYmqModal();
    if (fb && window.Globo && Globo.FormBuilder) {
      Globo.FormBuilder.showFloatingForm(fb);
    } else if (fb) {
      fb.click();
    }
    return false;
  }

  function bindYmqQuoteGloboFormOnce() {
    if (YMQCustom._globoQuoteClickBound) return;
    YMQCustom._globoQuoteClickBound = true;
    window.addEventListener(
      "click",
      function (e) {
        if (!isYmqQuoteRequestTarget(e.target)) return;
        openKigaeruGloboForm(e);
      },
      true,
    );
  }

  bindYmqQuoteGloboFormOnce();

  // Keep product form submit from adding to cart when quote button is used
  YMQCustom.submitProductQuoteForm = submitProductQuoteForm;

  // ============================================================
  // MODULE 2 — ESTIMATE BLOCK INJECTION
  // ============================================================
  function watchEstimateBlock(modalBox) {
    const ESTIMATE_TITLE = "見積内容説明";
    const block = document.getElementById(
      "product.metafield.custom.estimate_explanation",
    );
    const metafieldEmpty = !block || !(block.textContent || "").trim();

    function getTarget() {
      return (
        modalBox.querySelector(
          ".estimate_explanation > div.ymq-option-custome-text",
        ) ||
        modalBox.querySelector(
          ".estimate_explanation > div.ymq-option-custom-text",
        ) ||
        modalBox.querySelector("div.ymq-option-custome-text") ||
        modalBox.querySelector("div.ymq-option-custom-text")
      );
    }

    function hideEmptyEstimateTitle() {
      const group = modalBox.querySelector(".estimate_explanation");
      if (group) {
        group.classList.add("hidden", "ymq-estimate-empty");
        group.style.display = "none";
      }

      const target = getTarget();
      if (!target) return;
      target.querySelectorAll("strong").forEach((el) => {
        if ((el.textContent || "").trim() !== ESTIMATE_TITLE) return;
        const wrap = el.parentElement;
        if (wrap && wrap !== target) {
          wrap.style.display = "none";
        } else {
          el.style.display = "none";
        }
      });
    }

    function inject() {
      if (metafieldEmpty) {
        hideEmptyEstimateTitle();
        return;
      }

      const target = getTarget();
      if (!target || target.contains(block)) return;
      block.classList.remove("hidden");
      target.appendChild(block);
    }

    inject();
    YMQCustom.observeIdle(
      modalBox,
      { childList: true, subtree: true },
      inject,
      "estimate-block",
    );
  }

  // ============================================================
  // MODULE 3 — YMQ BUILT-IN MODAL SYNC
  // ============================================================
  function syncYmqModal(openPopup) {
    const ymqModal = document.getElementById("ymqmodal-option-list");
    if (!ymqModal) return;

    new MutationObserver(() => {
      const isOpen = ymqModal.classList.contains("ymq-modal-open");
      document.body.classList.toggle("ymq-no-scroll", isOpen);
      if (isOpen && YMQCustom.isQuoteProduct) {
        scheduleQuoteConfirmButtonSync();
      }
    }).observe(ymqModal, { attributes: true, attributeFilter: ["class"] });

    const closeBtn = ymqModal.querySelector("[data-ymqmodal-close]");
    if (closeBtn && !closeBtn.dataset.ymqReopenBound) {
      closeBtn.dataset.ymqReopenBound = "1";
      closeBtn.addEventListener("click", () => {
        // Sau khi gửi見積もり xong không mở lại custom modal
        if (YMQCustom._skipReopenCustomModal) {
          YMQCustom._skipReopenCustomModal = false;
          return;
        }
        setTimeout(openPopup, 200);
      });
    }
  }

  const WAITING_PARENT_TEXT = "上のオプションを先に選択してください";

  function isPlaceholderOptionText(text) {
    const value = (text || "").trim();
    if (!value) return true;
    if (/選択してください/.test(value)) return true;
    if (value === WAITING_PARENT_TEXT) return true;
    if (/^--.*--$/.test(value)) return true;
    return false;
  }

  function isRealSelectOption(opt) {
    if (!opt || opt.disabled || opt.hidden) return false;
    if (opt.dataset.placeholder) return false;
    if (!(opt.value || "").trim()) return false;
    if (isPlaceholderOptionText(opt.textContent)) return false;
    if (opt.style.display === "none") return false;
    return true;
  }

  function isRealDropdownItem(el) {
    if (!(el instanceof HTMLElement)) return false;
    if (el.hasAttribute("data-ymq-waiting-msg")) return false;
    if (el.classList.contains("ymq-option-condition-hide")) return false;
    if (el.classList.contains("ymq-select-hide")) return false;
    if (el.hidden || el.getAttribute("aria-disabled") === "true") return false;
    if (el.hasAttribute("disabled")) return false;
    if (isPlaceholderOptionText(el.textContent)) return false;
    if (el.style.display === "none" || el.style.visibility === "hidden") {
      return false;
    }
    if (getComputedStyle(el).display === "none") return false;
    return true;
  }

  function countPanelChoices(panel) {
    return [
      ...panel.querySelectorAll(
        ".ymq-option-select-option-wrapper, [ymq-option-item-value]",
      ),
    ].filter(isRealDropdownItem).length;
  }

  function boxHasSelectableValues(box) {
    const main = box.querySelector(".ymq-app-select-main");
    const dataId = main?.getAttribute("data-id");
    if (dataId) {
      const panels = document.querySelectorAll(
        `.ymq-app-select-content[data-id="${CSS.escape(dataId)}"]`,
      );
      if (panels.length) {
        return [...panels].some((panel) => countPanelChoices(panel) > 0);
      }
    }

    const select = box.querySelector("select");
    if (select) return [...select.options].some(isRealSelectOption);

    const inBox = [
      ...box.querySelectorAll(
        ".ymq-option-select-option-wrapper, [ymq-option-item-value]",
      ),
    ].filter(isRealDropdownItem);
    return inBox.length > 0;
  }

  function setWaitingPlaceholder(box, waiting) {
    const main = box.querySelector(".ymq-app-select-main");
    const placeholder = box.querySelector(".ymq-app-select-placeholder");
    if (main) main.classList.toggle("ymq-waiting-parent-select", waiting);
    box.classList.toggle("ymq-waiting-parent", waiting);
    if (!placeholder) return;

    if (waiting) {
      if (!placeholder.dataset.ymqDefaultText) {
        const current = (placeholder.textContent || "").trim();
        placeholder.dataset.ymqDefaultText = isPlaceholderOptionText(current)
          ? current || "--選択してください--"
          : "--選択してください--";
      }
      if (placeholder.textContent !== WAITING_PARENT_TEXT) {
        placeholder.textContent = WAITING_PARENT_TEXT;
      }
      return;
    }

    if (placeholder.textContent === WAITING_PARENT_TEXT) {
      placeholder.textContent =
        placeholder.dataset.ymqDefaultText || "--選択してください--";
    }
  }

  function syncEmptyPanelMessage(panel) {
    const empty = countPanelChoices(panel) === 0;
    let msg = panel.querySelector("[data-ymq-waiting-msg]");
    if (!empty) {
      msg?.remove();
      return;
    }
    if (!msg) {
      msg = document.createElement("div");
      msg.setAttribute("data-ymq-waiting-msg", "");
      msg.className = "ymq-waiting-parent-msg";
      msg.textContent = WAITING_PARENT_TEXT;
      panel.appendChild(msg);
    }
  }

  function syncWaitingParentSelects() {
    document.querySelectorAll(".ymq-options-box").forEach((box) => {
      if (!(box instanceof HTMLElement)) return;
      if (box.classList.contains("ymq-option-condition-hide")) return;
      if (box.classList.contains("button-quote-price")) return;
      if (box.classList.contains("estimate_explanation")) return;
      if (box.classList.contains("shipping_fee_auto_select")) return;
      if (box.classList.contains("ymq-shipping-address")) return;
      if (!box.querySelector(".ymq-app-select-main")) return;

      const filled = !box.querySelector(".ymq-app-select-placeholder");
      const waiting = !filled && !boxHasSelectableValues(box);
      setWaitingPlaceholder(box, waiting);
    });

    document.querySelectorAll(".ymq-app-select-content").forEach((panel) => {
      const dataId = panel.getAttribute("data-id");
      const main = dataId
        ? document.querySelector(
            `.ymq-app-select-main[data-id="${CSS.escape(dataId)}"]`,
          )
        : null;
      if (main?.classList.contains("ymq-waiting-parent-select")) {
        syncEmptyPanelMessage(panel);
      } else {
        panel.querySelector("[data-ymq-waiting-msg]")?.remove();
      }
    });
  }

  function watchWaitingParentSelects() {
    if (document._ymqWaitingParentBound) {
      syncWaitingParentSelects();
      return;
    }
    document._ymqWaitingParentBound = true;

    const run = () => {
      YMQCustom.schedule("waiting-parent-selects", syncWaitingParentSelects);
    };
    const runSoon = () => {
      run();
      clearTimeout(runSoon._t);
      runSoon._t = setTimeout(syncWaitingParentSelects, 120);
    };

    const root =
      document.querySelector("ymq-option") ||
      document.querySelector(".ymq-custom-modal-wrapper") ||
      document.body;
    YMQCustom.observeIdle(
      root,
      { childList: true, subtree: true, attributes: true, attributeFilter: ["class", "style", "hidden", "disabled"] },
      runSoon,
      "waiting-parent-selects",
    );
    YMQCustom.observeIdle(
      document.body,
      { childList: true, subtree: true },
      runSoon,
      "waiting-parent-selects-body",
    );

    document.addEventListener("change", runSoon, true);
    document.addEventListener(
      "click",
      (e) => {
        const el = e.target instanceof Element ? e.target : null;
        if (
          el?.closest(
            ".ymq-option-select-option-wrapper, .ymq-app-select-deselect, .ymq-app-select-main",
          )
        ) {
          runSoon();
        }
      },
      true,
    );

    syncWaitingParentSelects();
  }

  // ── Expose public API ──
  YMQCustom.buildCustomModal = buildCustomModal;
  YMQCustom.watchEstimateBlock = watchEstimateBlock;
  YMQCustom.syncYmqModal = syncYmqModal;
  YMQCustom.watchWaitingParentSelects = watchWaitingParentSelects;
  YMQCustom.applyQuoteProductState = applyQuoteProductState;
})();
